// "Complete your order" prompt. The first time the cart drawer opens with
// add-on suggestions in a visit, it copies those cards into a small dialog
// shown on top of the cart. Shown once per browser session.
const SEEN_KEY = 'proscentss-addon-prompt-seen';

class SAddonPrompt extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.items = this.querySelector('[data-addon-prompt-items]');
    this.drawer = document.getElementById('cart-drawer');
    if (!this.dialog || !this.items || !this.drawer) return;

    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.dialog.addEventListener('click', this.onClick);
    this.dialog.addEventListener('submit', this.onSubmit);

    this.observer = new MutationObserver(() => {
      if (this.drawer.open) this.schedule();
    });
    this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.dialog?.removeEventListener('click', this.onClick);
    this.dialog?.removeEventListener('submit', this.onSubmit);
    clearTimeout(this.timer);
  }

  seen() {
    try {
      return sessionStorage.getItem(SEEN_KEY) === '1';
    } catch {
      return false;
    }
  }

  markSeen() {
    try {
      sessionStorage.setItem(SEEN_KEY, '1');
    } catch {
      // Private browsing can block storage; the prompt then shows at most once per page.
    }
    this.shown = true;
  }

  schedule() {
    if (this.shown || this.seen()) return;
    clearTimeout(this.timer);
    // Let the drawer finish opening and its cart contents refresh first.
    this.timer = setTimeout(() => this.show(), 900);
  }

  show() {
    if (this.shown || this.seen() || !this.drawer.open || this.dialog.open) return;
    const list = this.drawer.querySelector('[data-cart-addons-list]');
    if (!list || !list.querySelector('li')) return;

    const copy = list.cloneNode(true);
    copy.removeAttribute('data-cart-addons-list');
    this.items.replaceChildren(copy);
    this.markSeen();
    this.dialog.showModal();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }

  onClick(event) {
    // Tapping the dimmed area outside the box closes it.
    if (event.target === this.dialog) {
      const rect = this.dialog.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left && event.clientX <= rect.right &&
        event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) this.close();
      return;
    }
    // Fallback for browsers without button commands.
    if (event.target.closest('[data-addon-prompt-close]')) this.close();
  }

  onSubmit() {
    // An add-on was added; give the cart a moment to update, then return to it.
    setTimeout(() => this.close(), 700);
  }
}

if (!customElements.get('s-addon-prompt')) customElements.define('s-addon-prompt', SAddonPrompt);
